import React, { Component } from 'react';

import Header from './components/Header';
import Intro from './containers/Intro/Intro';
import Theme from './containers/Theme';
import Lineup from './containers/Lineup';
import Ideas from './containers/Ideas';
import Partners from './containers/Partners';
import Info from './containers/Info';

import AppStore from './lib/flux/AppStore';
import AppActions from './lib/flux/AppActions';
import AppActionTypes from './lib/flux/AppActionTypes';
import NAV from './lib/navigation';

import { tickets, crossfade, speakers } from './lib/data';

import './App.scss';
import Modals from './containers/Modals/Modals';

class App extends Component {
  constructor(props) {
    require('events').EventEmitter.defaultMaxListeners = 20;
    super(props);
    this.state = {
      back: AppStore.getNavigation().back,
      location: AppStore.getNavigation().location
    }

    window.AppStore = AppStore;
    window.AppActions = AppActions;
    window.data = { tickets, crossfade, speakers };

    this.preloader();
  }


  loadImage = (src) => {
    return new Promise((resolve, reject) => {
      let img = new Image()
      img.onload = () => resolve(img.height)
      img.onerror = reject
      img.src = src
    })
  }

  preloader = async () => {
    // console.log('Loading up images based on order of appearance');

    // load the landing page images first
    for (let i = 0; i < crossfade.list.length; i++) {
      const group = crossfade.list[i];
      await this.loadImage(group.left);
      await this.loadImage(group.right);
      crossfade.list[i].loaded = true;
    }

    // load the profile images
    setTimeout(async () => {
      for (let i = 0; i < speakers.list.length; i++) {
        let id = speakers.list[i];
        let speaker = speakers.dictionary[id];
        await this.loadImage(speaker.image)
        speakers.dictionary[id].loaded = true;
      }
    }, 1000)
  }

  componentDidMount() {
    AppStore.on(AppActionTypes.NAVIGATION, this._handleStoreNavigationChange);
    this.preventBackSwipe()
    // setTimeout(() => {AppActions.header({ collapsed: true });},1000)
  }

  componentWillUnmount() {
    AppStore.removeListener(AppActionTypes.NAVIGATION, this._handleStoreNavigationChange);

  }

  preventBackSwipe = () => {
    window.history.pushState(null, null, window.location.href);
    window.onpopstate = function () {
      window.history.go(1);
    };
  }

  _handleStoreNavigationChange = ({ back, location }) => {
    // console.log({ back, location })
    this.setState({ back, location })
  }

  build = () => {
    switch (this.state.location) {
      case NAV.INTRO:
        return (<Intro />)
      case NAV.THEME:
        return (<Theme />)
      case NAV.LINEUP:
        return (<Lineup />)
      case NAV.IDEAS:
        return (<Ideas />)
      case NAV.PARTNERS:
        return (<Partners />)
      case NAV.INFO:
        return (<Info />)
      default:
        return (<Intro />)
    }
  }

  render() {
    return (
      <div className="app-container">
        <Modals />
        <Header />
        {this.build()}
      </div>
    );
  }
}

export default App;
